export default {
    props: {
        excelAllPages: {
            type: Boolean,
            kComposite: 'excel.allPages'
        }, 
        excelFileName: {
            type: String,
            kComposite: 'excel.fileName'
        }, 
        excelFilterable: {
            type: Boolean,
            kComposite: 'excel.filterable'
        }, 
        excelForceProxy: {
            type: Boolean,
            kComposite: 'excel.forceProxy'
        }, 
        excelProxyURL: {
            type: String,
            kComposite: 'excel.proxyURL'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Excel.js